import(/* webpackMode: "eager" */ "/app/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/lib/QueryProvider.tsx");
